import React from 'react';
import PropTypes from 'prop-types';
import { Column } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { AddressDetail } from './AddressDetail';
import { AddressType } from '../../../constants/addressType';

export const BillingDetails = ({ billing = {}, columnStyle = {} }) => {
  const [shippingBillingCard] = useTranslations(['shippingBillingCard']);
  const { span, px, py } = columnStyle;

  return (
    <Column span={span} px={px} py={py}>
      <AddressDetail
        address={billing}
        title={shippingBillingCard.billingAddress}
        addressType={AddressType.BILLING}
      />
    </Column>
  );
};

BillingDetails.propTypes = {
  billing: PropTypes.object,
  columnStyle: PropTypes.object,
};
